import { useTreeDispatchContext } from '../contexts/TreeContext';
import BotService from '../services/BotService';
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import { useBotDispatchContext } from "../contexts/BotContext";
import { useBotStateContext } from "../contexts/BotContext";
import BlockService from '../services/BlockService';
import BlockChildService from '../services/BlockChildService';
import PathService from '../services/PathService';
import useErrorCheckEditor from '../hook/useErrorCheckEditor';
import { isEmpty } from 'lodash';
import BlocksList from '../data/constant/BlocksList';
import createBlockUtil from '../utils/createBlock';
import CategoryService from '../services/CategoryService';

function editorAction() {


    const { getBotInformations, addVariable : addVariableservice , deleteVariable : deleteVariableService, importTemplate } = BotService

    const { updateBlockName, updateBlockData, updateBlocksPosition : updateBlocksPositionService, createBlock, deleteBlock, updateBlockHaveStatistic, updateBlocksName : updateBlocksNameService } = BlockService

    const { addPath : addPathService, deletePath : deletePathService } = PathService

    const { createCategory : createCategoryService, updateCategory : updateCategoryService, deleteCategory : deleteCategoryService,addBlocksInCategory : addBlocksInCategoryService, substractBlocksFromCategory : substractBlocksFromCategoryService} = CategoryService

    const { 
        updateBlockChild : updateBlockChildService, 
        createBlockChild : createBlockChildService, 
        deleteBlockChild : deleteBlockChildService, 
        updateBlockChildren : updateBlockChildrenService 
    } = BlockChildService

    const dispatch = useTreeDispatchContext();

    const botDispatch = useBotDispatchContext();

    const toast = useToastDispatchContext();

    const { botId } = useBotStateContext();

    const { checkErrors, checkErrorsForPath } = useErrorCheckEditor();

    const actionGetBotInformations = async (name, dispatchLoading = true) => {

        if(dispatchLoading) {
            dispatch({type : 'loadBotPending'})
        }
        

        const [response, error] = await getBotInformations(name);
        if(error !== null) {
            const { status } = error;
            if(status == 422) return error;
            toast.error('Error during loading', 'Cannot fetch bot data');
            return;
        }

        var { blocks, variables, children, paths, company_id, id, phone, code,categories } = response;
        const block_scenarios = blocks.filter(block => block.data.basic);
        const block_start = block_scenarios ? block_scenarios[0] : null;

        blocks = blocks.map(block => {
            if(block.children !== undefined) {
                block.children.sort((a, b) => a.index - b.index)
            }
            return {...block}
        });

        if(blocks.length == 0) {
            const { scenario } = BlocksList;
            scenario.tree.name = "User Connected"
            scenario.tree.data.basic = 1;
            scenario.server.basic = 1;
            const { block, blockServer, children } = createBlockUtil(scenario, 0, 0, 30, 120)
            addBlock(block, blockServer, children, id)
        }

        botDispatch({type : 'setInfo', payload : { variables, id, company_id, block_start, name, code, phone } });

        if(blocks.length) {
            checkErrors(blocks, paths, children);
            dispatch({type : 'loadBotSuccess', payload : { blocks, children, paths, categories }})
            return;
        }

        dispatch({type : 'setFetching', payload : { fetching : false }})
        return;
    }

    const addBlock = async (block, blockServer, children, botIdToSend = 0) => {
        dispatch({type : 'addBlock', payload : {block, children}})

        botIdToSend = botIdToSend ? botIdToSend : botId;
        const [response, error] = await createBlock(botIdToSend, blockServer);
        if(error !== null) {
            toast.error('Block not created', 'Oups something go wrong check your internet connexion');
            console.log(error)
        }

        if(children) {
            for(var i = 0; i < children.length; i++) {
                const child = children[i];
                createBlockChildService(botIdToSend, block.object_id, child);
            }
        }
        checkErrors()
    }
    return {
        addBlockTemplate : async (block) => {
            dispatch({type : 'addBlock', payload : {block, children : []}})
        },
        deleteVariable : async (id) => { 
            botDispatch({type : 'deleteVariable', payload : { id }})
            const [response, error] = await deleteVariableService(botId, id);
            if(error === null) {
                toast.success('Variable deleted', 'Congrats variable has been deleted 🎉🎉');
            }
            
        },
        addVariable : async (data) => {
            
            const [response, error] = await addVariableservice(botId, data);
            if(error !== null) {
                console.log(error)
                return false;
            }

            toast.success('Variable Add', 'Congrats variable ' + data.name.toUpperCase() + ' has been created 🎉🎉');
            const variable = {
                id : response.id,
                name : data.name,
                type : { name : data.type }
            }

            botDispatch({type : 'addVariable', payload : { variable } })
            return true;
        },
        updateVariable: (variable, type, id) => {
            // TODO dispatch({type : 'updateVariable', payload : {block, children}})
        },
        updateBlocksPosition : async (blocks) => {
            for(let index in blocks) {
                let block = blocks[index];
                const { object_id, x, y } = block
                dispatch({type : 'updateBlockPosition', payload : { id : object_id, x, y }})
            }

            const [response, error] = await updateBlocksPositionService(botId, blocks)
            if(error !== null) {
                console.log(error)
                return false;
            }

        },
        updateBlocksName : async (blocks) => {
            for(let index in blocks) {
                let block = blocks[index];
                const { object_id, name, type } = block
                dispatch({type : 'updateBlockName', payload : { id : object_id, name}})
                if(type.name !== 'magic') {
                    continue;
                }
                dispatch({type : 'updateBlockMagic', payload : { id : object_id }})
            }

            const [response, error] = await updateBlocksNameService(botId, blocks)
            if(error !== null) {
                console.log(error)
                return false;
            }

        },
        updateBlockPosition : async (id, x, y) => dispatch({type : 'updateBlockPosition', payload : { id, x, y }}),
        updateBlockName : async (id, name) => {
            const [response, error] = await updateBlockName(botId, id, name);
            if(error !== null) {
                console.log(error)
            }
            dispatch({type : 'updateBlockName', payload : { id, name }})
        },
        updateBlockData : async (id, data, dataServer = {}) => {
            if(isEmpty(dataServer)) {
                dataServer = { ...data }
            }

            if(data.name) {
                dispatch({ type : 'updateBlockName', payload : {id, name : dataServer.name }})
                delete data.name
            }

            botDispatch({type : 'onUpdate', payload : { onUpdate : true}})
            const [response, error] = await updateBlockData(botId, id, dataServer);
            botDispatch({type : 'onUpdate', payload : { onUpdate : false}})
            if(error !== null) {
                console.log(error)
            }

            dispatch({type : 'updateBlockData', payload : { id, data }})
        },
        updateBlock : async (id, data, dataServer, children) => {
            if(isEmpty(dataServer)) {
                dataServer = data
            }

            if(data.action_type) {
                dispatch({ type : 'updateBlockTypeAction', payload : {id, type : data.action_type }})
                dataServer.action_type = data.action_type.name
            }

            if(data.name) {
                dispatch({ type : 'updateBlockName', payload : {id, name : data.name }})
                dataServer.name = data.name
            }

            if(data.children) {
                for(var i = 0; i < children.length; i++) {
                    const child = children[i];
                    dispatch({ type : 'createBlockChild', payload : {block_id : id, data : child}})
                }
            }
            
            dispatch({type : 'updateBlockData', payload : { id, data : data.data }})
            
            const [response, error] = await updateBlockData(botId, id, dataServer);
            if(error !== null) {
                console.log(error)
            }

            if(data.children) {
                for(var i = 0; i < children.length; i++) {
                    const child = children[i];
                    createBlockChildService(botId, id, child);
                }
            }
        },
        updateBlockDataJump : async (id, name, jump, blockIdInteger,is_constant,variable_value) => {
            const [response, error] = await updateBlockData(botId, id, { name, jump_id : jump?.object_id, is_constant : is_constant, variable_value : variable_value } );
            if(error !== null) {
                console.log(error)
            }

            dispatch({type : 'updateBlockName', payload : { id, name }})
            dispatch({type : 'updateBlockData', payload : { id, data : {block_id : blockIdInteger, jump_id : jump,is_constant : is_constant, variable_value : variable_value} }})

            setTimeout(() => checkErrors(), 200)
        },
        updateBlockStatistic : async (block_id, is_statistic) => {
            dispatch({ type : 'updateBlockStatistics', payload : { id : block_id, is_statistic}})
            const [response, error] = await updateBlockHaveStatistic(botId, block_id, is_statistic);
            if(error !== null) {
                console.log(error)
                return
            }
            
            if(is_statistic == 1) {
                toast.success('Statistics enabled', 'Congrats some statistics has been created 🎉🎉');
            }
            else if(is_statistic == 0) {
                toast.warning('Statistice disabled', 'Warning some statistics has been disabled ⚠️⚠️')
            }
        },
        updateBlockVisibility : async (blocks, paths) => dispatch({type : 'updateBlockVisibility', payload : { blocks, paths }}),
        importBlockTemplate : async (id, data) => {
            dispatch({ type : 'deleteBlock', payload : {id}})
            var [response, error] = await importTemplate(botId, data);
            if(error !== null) {
                console.log(error)
                return false;
            }

            toast.success('Scenario Imported', 'Congrats variable your scenario have been imported 🎉🎉');

            actionGetBotInformations(botId, false);
            
        },
        deleteBlock : async (id) => {
            dispatch({ type : 'deleteBlock', payload : {id}})
            const [response, error] = await deleteBlock(botId, id);
            if(error !== null) {
                toast.error('Block not deleted', 'Oups something go wrong');
                console.log(error)
            }
            checkErrors()
        },
        createBlockChild : async (block_id, data) => {
            const [response, error] = await createBlockChildService(botId, block_id, data);
            if(error !== null) {
                console.log(error)
            }
            checkErrors()
        },
        updateBlockChild : async (block_id, object_id, data) => {
            const [response, error] = await updateBlockChildService(botId, block_id, object_id, data);
            if(error !== null) {
                console.log(error)
            }
        },
        updateBlockChildren : async (block_id, children) => {
            const [response, error] = await updateBlockChildrenService(botId, block_id, children);
            if(error !== null) {
                console.log(error)
            }
        },
        deleteBlockChild : async (block_id, object_id) => {
            const [response, error] = await deleteBlockChildService(botId, block_id, object_id);
            if(error !== null) {
                console.log(error)
            }
            checkErrors()
        },
        deletePath : async (id) => {
            dispatch({ type : 'deletePath', payload : {id}})

            const [response, error] = await deletePathService(botId, id)
            if(error !== null) {
                console.log(error)
                return false;
            }
            checkErrors()
        },
        createPath : async (parent_block_id, path_id, child_block_id) => {
            dispatch({ type : 'createPath', payload : { parent_block_id, path_id, child_block_id }})

            const [response, error] = await addPathService(botId, {child_id : child_block_id, parent_id : parent_block_id, object_id : path_id})
            if(error !== null) {
                console.log(error)
                return false;
            }
            checkErrorsForPath()
        },
        createCategory: async (category) => {
            category.bot_id = botId
            const [res, errors] = await createCategoryService(botId, category)
            if (errors != null) {
                console.log(errors)
                toast.error('Error', errors.data, 5000);
                return;
            }
            dispatch({ type : 'createCategory', payload : { ...res }})
            toast.success('Success', 'A new category has been created !');
        },
        
        updateCategory : async (category_ids, data) => {
            category_ids = Array.isArray(category_ids) ? category_ids : [category_ids] // quand on bouge un block, ca peut etre une liste d'id, sinon c'est tjr un unique id

            for (let i = 0; i < category_ids.length; i++){
                let id = category_ids[i]
                data = data ?? {id : id} // pour le move block
                const [res, error] = await updateCategoryService(botId, id, data);
                if (error != null) {
                    console.error(error);
                    return;
                }
                dispatch({ type : 'updateCategory', payload : { id : id, category : res}})
            }
            if (Array.isArray(category_ids == false)){ // pour afficher le toast uniquement quand le update viens de la structure et pas d'un mouvement
                toast.success('Success', 'A category has been updated');
            }
        },

        deleteCategory : async (category_id,data) => {
            dispatch({ type : 'deleteCategory', payload : { id :category_id }})
            const [res, error] = await deleteCategoryService(botId, category_id, data);
            if (error != null) {
                console.error(error);
                return;
            }
            toast.success('Success', 'A category has been deleted');
        },

        addBlocksInCategory : async (category_id, data) =>{
            const [res, errors] = await addBlocksInCategoryService(botId,category_id, data)
            if (errors != null) {
                console.log(errors)
                toast.error('Error', errors.data, 5000);
                return;
            }
            toast.success('Success', 'A selection of blocks has been added into the category');
            dispatch({ type : 'updateCategory', payload : { id :category_id, category : res}})

        },

        ungroupBlockFromCategory : async (block,data) =>{
            const [res, errors] = await substractBlocksFromCategoryService(botId, block.bot_category_id, block.object_id, data);
            if (errors != null) {
                console.log(errors)
                toast.error('Error', errors.data, 5000);
                return;
            }
            dispatch({ type : 'ungroupBlockFromCategory', payload : { id : block.bot_category_id, infoCategory : res, block_object_id : block.object_id}})

            toast.success('Success', 'A block has been removed from category');
        },
        setCtrlKey : (ctrlKey = false) => dispatch({ type : 'setCtrlKey', payload : { ctrlKey }}),
        setShitKey : (shiftKey = false) => dispatch({ type : 'setShiftKey', payload : { shiftKey }}),
        setPressDown: (pressDown = false) => dispatch({ type : 'setPressDown', payload : { pressDown }}),
        setZoneSelectBlocks : (x, y) => dispatch({ type : 'setZoneSelectBlocks', payload : { x, y }}),
        actionGetBotInformations,
        addBlock

    };
}

export default editorAction;